// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGMeasureIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGMeasureIcon extends PureComponent<
  ISVGMeasureIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
        preserveAspectRatio="none"
      >
        <g>
          <title>background</title>
          <rect
            x="-1"
            y="-1"
            width="37"
            height="37"
            id="canvas_background"
            fill="none"
          />
        </g>

        <g>
          <title>Layer 1</title>
          <path
            stroke="null"
            fillRule="evenodd"
            clipRule="evenodd"
            d="m32.922669,6.136459c-1.294401,-1.293422 -2.58783,-2.587823 -3.882231,-3.881245c-0.872985,-0.873964 -1.304128,-1.800486 -3.103636,-1.785881c-0.197566,0.157663 -0.480774,0.162527 -0.698781,0.310455c-2.302665,2.328948 -4.606309,4.65789 -6.908975,6.98586c-3.959109,3.959116 -7.917246,7.918218 -11.877327,11.878305c-1.345981,1.345003 -2.691963,2.690013 -4.036966,4.035994c-0.597569,0.598534 -1.526028,1.191232 -1.862766,2.018479c-0.174211,0.427251 -0.03309,1.033576 0,1.475419c0.205351,0.203408 0.288072,0.46034 0.465204,0.698788c1.630161,1.603885 3.261299,3.20874 4.890489,4.813603c0.515813,0.514842 1.321648,1.78783 2.484662,1.552304c1.121168,-0.227735 1.65158,-1.107541 2.328948,-1.784909c1.345003,-1.345974 2.690984,-2.690984 4.035994,-4.035994c4.631614,-4.632585 9.264199,-9.264192 13.895806,-13.895806c1.294401,-1.294401 2.58783,-2.587823 3.881252,-3.882224c0.510949,-0.509978 1.381014,-1.052067 1.630167,-1.784909c0.454498,-1.335275 -0.657906,-2.133325 -1.241849,-2.718239l0.000007,0zm-1.241849,3.881252c-1.57858,1.57858 -3.157167,3.157167 -4.734775,4.734775c-4.088546,4.114822 -8.178071,8.229651 -12.266617,12.343502c-2.017515,1.99221 -4.035994,3.985392 -6.05448,5.977595c-1.210702,0.072021 -1.650601,-0.873964 -2.328942,-1.553282c-1.63406,-1.633082 -3.354733,-3.156188 -4.81361,-4.967374c0.074942,-0.916781 0.768853,-1.121161 1.163985,-1.708024c0.525548,0.108032 0.765932,0.61119 1.0871,0.932358c0.813627,0.812648 1.930895,1.593178 2.562525,2.561547c0.633573,0.027247 0.855466,-0.082727 0.853523,-0.698781c-1.164963,-1.190261 -2.32992,-2.3815 -3.493905,-3.57079c-0.025305,0 -0.051581,0 -0.077857,0c0,-0.025305 0,-0.051581 0,-0.077857c0.620917,-0.594648 1.241842,-1.190268 1.863737,-1.784909c0.071043,-0.083699 -0.005842,-0.007785 0.077857,-0.077857c0.413623,0.439899 0.828225,0.878828 1.241849,1.318727c0.633573,0.028226 0.855466,-0.082727 0.853523,-0.698781c-0.44477,-0.419466 -0.801942,-0.978096 -1.319705,-1.318727c0.28905,-0.802921 1.324569,-1.251576 1.784909,-1.94063c0.523598,0.184917 1.113376,0.926516 1.475419,1.319705c0.540147,-0.007785 0.520684,-0.136251 0.775666,-0.388319c-0.057416,-0.670555 -0.860336,-1.338196 -1.319698,-1.630167c0.28905,-0.803885 1.324569,-1.251576 1.785881,-1.941594c0.52262,0.18491 1.113376,0.926516 1.474447,1.319698c0.328953,-0.01362 0.414595,-0.061308 0.621896,-0.154742c0.050602,-0.155713 0.103161,-0.310462 0.154742,-0.466175c-0.413623,-0.483695 -0.781508,-1.045254 -1.318727,-1.397562c0.091484,-0.458391 1.400476,-1.694397 1.784902,-1.941601c0,-0.025305 0,-0.051581 0,-0.077857c0.026283,0 0.052559,0 0.077864,0c0.264717,0.399025 0.677369,0.676397 1.009236,1.009243c0.850609,0.84963 1.739171,1.687583 2.562525,2.561547c0.212165,-0.000978 0.356201,-0.00195 0.465204,-0.077864c0.077857,-0.026276 0.15572,-0.051581 0.232605,-0.077857c0.050602,-0.134308 0.01557,-0.075914 0.077857,-0.155713c-0.031147,-0.787351 -0.509978,-0.86715 -0.931386,-1.241849c-0.90024,-0.801942 -2.117755,-1.714838 -2.795124,-2.71726c-0.026276,0 -0.051581,0 -0.077857,0c0,-0.025305 0,-0.051588 0,-0.077864c0.620924,-0.594641 1.241849,-1.190261 1.863737,-1.784909c0,-0.025298 0,-0.051581 0,-0.077857c0.025305,0 0.051588,0 0.077864,0c0.341602,0.517763 0.899268,0.876885 1.319698,1.319705c0.212165,-0.000971 0.355236,-0.002921 0.465211,-0.077857c0.077857,-0.025305 0.155713,-0.051588 0.232599,-0.077864c0.050609,-0.13333 0.01557,-0.076885 0.078835,-0.155713c-0.018498,-0.746469 -0.839903,-1.405347 -1.319705,-1.707053c0.28905,-0.803892 1.325541,-1.251576 1.784909,-1.941594c0.324082,0.114839 1.279802,1.036491 1.475419,1.319698c0.464233,-0.019462 0.508028,-0.137222 0.776638,-0.310462c-0.018491,-0.76301 -0.828218,-1.394641 -1.319705,-1.704125c0.157663,-0.448663 1.453035,-1.675906 1.863744,-1.94063c0,-0.026276 0,-0.052552 0,-0.078828c0.025305,0 0.051581,0 0.077857,0c0.261796,0.405838 0.942093,1.219458 1.475419,1.319705c0.130416,0.066179 0.24039,0.036982 0.387347,-0.077864c0.105111,-0.077857 0.141122,-0.149878 0.233577,-0.233577c-0.060344,-0.736734 -0.823354,-1.392691 -1.319705,-1.707046c0.28905,-0.803892 1.324569,-1.251576 1.785881,-1.941601c0.499272,0.180053 0.815569,0.738684 1.163985,1.0871c0.85353,0.828225 1.708024,1.656443 2.561547,2.484662c0.196595,-0.007785 0.287107,-0.009728 0.387347,-0.077857c0.304627,-0.115817 0.323118,-0.276394 0.310462,-0.69781c-0.846709,-0.79805 -1.660336,-1.661307 -2.48369,-2.484662c-0.332846,-0.331867 -0.610218,-0.745491 -1.009243,-1.009236c0.197566,-0.557666 0.859365,-0.921652 1.241849,-1.319705c0.232599,0 0.466175,0 0.698781,0c2.061304,2.19464 4.263729,4.281249 6.364936,6.443771c-0.068122,0.985881 -1.080286,1.546469 -1.630161,2.096343z"
            id="svg_1"
          />
        </g>
      </svg>
    );
  }
}
